<template>
  <a-modal
      :title="`${actType}小组`"
      centered
      :width="850"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="model.name"/>
      </a-form-model-item>
      <a-form-model-item label="所属主体" prop="corporation_id">
        <a-select show-search allow-clear placeholder="请选择" v-model="model.corporation_id"  option-filter-prop="children" @change="changeCorporation">
          <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
            {{ corporation.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="主体类型" prop="media_corporation_type">
        <a-radio-group :default-value="1" button-style="solid" v-model="model.media_corporation_type" @change="changeMediaCorporationType(model.media_corporation_type)">
          <a-radio-button :value="1">
            小程序
          </a-radio-button>
          <a-radio-button :value="2">
            端原生
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="媒体主体" prop="media_corporations">

        <!-- 1. 选择器 -->
        <a-select
          mode="multiple"
          show-search
          allow-clear
          placeholder="请选择"
          v-model="model.media_corporations"
          :maxTagCount="0" 
          option-filter-prop="children"
        >
          <a-select-option
            :value="item"
            v-for="item in mediaCorporations"
            :key="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      
        <!-- 2. 自定义展示区 -->
        <div class="drag-tags-placeholder" v-if="model.media_corporations && model.media_corporations.length === 0">
          暂无已选项，请从上方选择
        </div>
        <div ref="dragContainer" class="drag-tags" v-else>
          <div
            v-for="item in model.media_corporations"
            :key="item"
            class="draggable-tag"
            title="拖动排序"
          >
            <span class="tag-label">{{ item }}</span>
            <span class="tag-close" @click="removeSelected(item)">×</span>
          </div>
        </div>
      </a-form-model-item>
      
    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
